import * as React from "react";
const SvgFiRrFacePensive = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-face-pensive_svg__a)">
      <path
        fill="#062147"
        d="M16 18a1 1 0 0 1-1 1H9a1 1 0 1 1 0-2h6a1 1 0 0 1 1 1m1.273-5.651c-.351.404-.867.69-1.302.651-.424-.002-.82-.219-1.179-.643a1.001 1.001 0 0 0-1.527 1.293c.938 1.107 1.983 1.346 2.694 1.35h.019c1.029 0 2.077-.5 2.807-1.341a1.001 1.001 0 0 0-1.512-1.31m-6.589-.101a1 1 0 0 0-1.411.101c-.349.402-.844.651-1.295.651h-.007c-.424-.002-.82-.219-1.179-.643a1.001 1.001 0 0 0-1.527 1.293c.938 1.107 1.983 1.346 2.694 1.35h.019c1.029 0 2.077-.5 2.807-1.341a1 1 0 0 0-.101-1.411M23.999 12c0 6.617-5.383 12-12 12S0 18.617 0 12 5.383 0 12 0s11.999 5.383 11.999 12m-2 0c0-5.514-4.486-10-10-10S2 6.486 2 12s4.486 10 10 10 9.999-4.486 9.999-10m-4.274-3.038Q17.863 9 18 9a1 1 0 0 0 .273-1.962c-.964-.275-1.977-.941-2.461-1.619a1 1 0 1 0-1.627 1.163c.746 1.045 2.136 1.979 3.539 2.381zM5.998 9q.138 0 .275-.038c1.403-.401 2.793-1.336 3.539-2.381a1 1 0 0 0-1.627-1.163c-.484.678-1.497 1.344-2.461 1.619a1.001 1.001 0 0 0 .273 1.962z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-face-pensive_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrFacePensive;
